<template lang="pug">
span.root
  .search-query
    .search-query__form
      .search-query__container
        input.search-query__input(
          type="text",
          v-model="queryModel",
          :placeholder="options.queryPlaceholderText",
          @keydown.enter.stop="executeSearch()"
        )
        //ul.search-query__keywords(v-if="keywords.length > 0")
        //  li.search-query__keyword(v-for="item in keywords")
        //    button(@click="searchForKeyword(item)", @keydown.enter.stop="searchForKeyword(item)")
        //      div
        //        p.title {{item.title}}
        //        p.summary {{item.summary}}

      button.search-query__submit(@click="executeSearch()")
        span {{ options.querySubmitText }}

      .search-query__sort
        select(v-model="sortModel")
          option(v-for="option in results.sortOptions", :value="option") Sort by {{ option.displayName }}
        .select-arrow
    small.search-query__results {{ label }}

</template>

<script>
export default {
  name: "OCCQuery",
  props: {
    query: String,
    setQuery: Function,
    sort: Object,
    setSort: Function,
    results: Object,
    executeSearch: Function,
    currentResultsStart: Number,
    currentResultsEnd: Number,
  },
  data() {
    return {
      keywords: [],
    };
  },
  watch: {
    query() {
      if (this.query.trim().length > 3) {
        fetch(this.options.keywordsEndpoint, {
          method: 'post',
          body: JSON.stringify(this.query.trim())
        })
          .then(response => response.json())
          .then(data => {
            this.keywords = data.results;
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }
    }
  },
  computed: {
    label() {
      return `Results ${this.currentResultsStart} - ${this.currentResultsEnd} of ${this.results.totalResultCount}`;
    },
    queryModel: {
      get() {
        return this.query;
      },
      set(val) {
        this.setQuery(val);
      },
    },
    sortModel: {
      get() {
        return this.sort;
      },
      set(val) {
        this.setSort(val);
      },
    },
  },
  methods: {
    // searchForKeyword(el) {
    //  this.setQuery(el.title);
    //  this.executeSearch();
    //  this.setQuery('');
    //  this.keywords = [];
    // }
  }
};
</script>


<style lang="scss" scoped>
span.root {
  display: contents;
}

.search-query {
  display: flex;
  flex-direction: column;
  padding-bottom: 1.5rem;
  margin: 0;
  flex: 1 1 100%;

  &__form {
    display: flex;
    position: relative;
    flex: 1 1 100%;
    padding: 0;
    margin: 0;
  }

  &__container {
    flex: 1 1 100%;
    width: 100%;
    position: relative;
  }

  &__input {
    @include clean(input);
    width: 100%;
    margin: 0;
    padding: 1rem;
    border: 1px solid var(--border-color);

    &:focus {
      outline: none;
      border: 1px solid $red;
    }

    &::placeholder {
      color: var(--color);
      font-weight: 300;
    }
  }

  &__keywords {
    position: absolute;
    list-style-type: none;
    padding-left: 0;
    padding-top: 1rem;
    padding-bottom: 1rem;
    left: 0;
    right: 0;
    width: 100%;
    top: 3.25rem;
    height: 20rem;
    background: $white;
    border: 1px solid var(--border-color);
    overflow-y: scroll;
    z-index: 2;
  }

  &__keyword {
    &:nth-child(odd) {
      background-color: $lightGray;
    }

    button {
      cursor: pointer;
      border: 0;
      padding: .5rem 1rem;
      min-height: 2.5rem;
      text-align: left;
      width: 100%;
      background: transparent;
      transition: ease .25s;

      div {
        display: flex;
        flex-direction: column;

        .title {
          font-weight: 600;
          margin-bottom: .25rem;
        }

        .summary {
          margin: 0;
          font-size: .875rem;
        }

        p {
          width: 100%;

        }
      }

      &:focus {
        outline: none !important;
        background: $red;
        color: $white;
      }
    }
  }

  &__submit {
    @include clean(button);
    flex: 0 0 auto;
    padding: 0 1rem;
    background: var(--button-background);
    color: var(--button-color);
    transition: var(--button-transition);

    &:hover {
      background: var(--button-hover-background);
      color: var(--button-hover-color);
    }
  }

  &__sort {
    position: relative;
    flex: 0 0 auto;
    margin: 0;
    margin-left: 1rem;
    border: 1px solid var(--border-color);
    display: flex;
    align-items: center;

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: 1.25rem;
      height: 0.5rem;
      width: 0.5rem;
      border-left: 2px solid;
      border-bottom: 2px solid;
      transform: translate(50%, -75%) rotate(-45deg);
    }

    select {
      @include clean(input);
      cursor: pointer;
      padding: 1rem;
      padding-right: 2.5rem;
    }
  }

  &__results {
    line-height: 1;
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    align-self: flex-start;
    background: var(--label-background);
    color: var(--label-color);
  }
}
</style>